angular.module('unergie.main')
.controller('staggerGeneratePaymentModalCtrl', (
    $scope, $uibModalInstance, AdminComments, DataAccess, MetaWatcher, AlertManager, ErrorCatcher, AuthService, BoFeaturesService, MS, PaymentService,
    paymentPayload, overdueMode, noMandate) => {
    $scope.initialPayment = paymentPayload
    $scope.noMandate = noMandate
    $scope.overdueMode = overdueMode
    $scope.paymentFields = PaymentService.newPaymentFields()
    const feats = BoFeaturesService.getModuleFeatures('contracts')
    $scope.freePaymentNumber = feats.staggerNoLimit
    $scope.payments = [{ amount: $scope.initialPayment.amount, payment_date: moment($scope.initialPayment.payment_date).format('DDMMYYYY') }]

    $scope.nbPayments = 1

    $scope.overdueModeParams = {
        TERMINATION_REQUESTED: { message: 'La résiliation a été demandée', totality: false },
        SUSPENDED: { message: 'Le client est coupé', totality: true },
        SUSPENSION_REQUESTED: { message: 'Une coupure a été demandée', totality: false },
        LIMITED: { message: 'Le client est limité', totality: true },
        LIMITATION_REQUESTED: { message: 'Une limitation a été demandée', totality: false },
    }[overdueMode]

    if (noMandate) {
        $scope.overdueModeParams = { message: 'Le mandat du client est révoqué', totality: true }
    }

    $scope.forceTotality = $scope.overdueModeParams && $scope.overdueModeParams.totality

    $scope.min = 1
    $scope.max = $scope.initialPayment.amount
    $scope.providerInitiative = false
    $scope.displayInitiative = BoFeaturesService.get('canPlaceProviderPayment') && !overdueMode
    $scope.initiativeOptions = $scope.displayInitiative ? $scope.paymentFields.providerInitiative.enum : []

    $scope.cbModes = PaymentService.paymentMailFields().mode.enum

    $scope.paymentNumbers = []
    const maxPayements = feats.canViewStaggerMonths ? 12 : 6
    for (let i = 1; i <= maxPayements; i++) {
        $scope.paymentNumbers.push(i)
    }

    const sum = () => {
        $scope.sumPayment = MS.round(_.sumBy($scope.payments, (p) => Number(p.amount)) + $scope.cb.amount, 2)
    }

    $scope.cb = PaymentService.paymentMailPayload()

    const getTotalToDistribute = () => {
        return MS.round($scope.initialPayment.amount - $scope.cb.amount, 2)
    }

    $scope.getTotalToDistribute = getTotalToDistribute

    $scope.calculateCb = () => {
        if ($scope.overdueModeParams && $scope.overdueModeParams.totality) {
            $scope.totality = $scope.overdueModeParams.totality
        }
        if ($scope.totality || ($scope.overdueModeParams && $scope.overdueModeParams.totality)) {
            $scope.cb.amount = $scope.initialPayment.amount
            $scope.payments = []
        } else if ($scope.totality != null) {
            $scope.cb.amount = MS.round($scope.initialPayment.amount / 2, 2)
            $scope.payments = [{ amount: getTotalToDistribute(), payment_date: moment($scope.initialPayment.payment_date).format('DDMMYYYY') }]
        }
    }
    $scope.calculateCb()


    $scope.updateNbPayments = () => {
        $scope.payments = []
        const date = moment($scope.initialPayment.payment_date)
        for (let i = 0; i < $scope.nbPayments; i += 1) {
            $scope.payments.push({
                id: i,
                payment_date: date.format('DDMMYYYY'),
                amount: MS.round($scope.getTotalToDistribute() / $scope.nbPayments, 2),
            })
            date.add(1, 'month')
        }
        $scope.payments[0].amount = MS.round(($scope.payments[0].amount + $scope.getTotalToDistribute()) - _.sumBy($scope.payments, 'amount'), 2)
        sum()
    }

    $scope.onChangeInitiative = () => {
        if ($scope.providerInitiative) {
            $scope.nbPayments = 1
            $scope.updateNbPayments()
        }
    }

    $scope.onChangeDate = (changedPayment) => {
        if (changedPayment.payment_date) {
            const date = moment(changedPayment.payment_date, 'DDMMYYYY')
            if (date.isValid()) {
                $scope.initialPayment.payment_date = date
                _.each(_.orderBy($scope.payments, 'id', 'asc'), (np) => {
                    if (np.id > 0) {
                        date.add(1, 'month')
                        np.payment_date = date.format('DDMMYYYY')
                    }
                })
            }
        }
    }

    $scope.canSubmit = () => {
        return $scope.nbPayments === 1 || ($scope.sumPayment === $scope.initialPayment.amount && _.every($scope.payments, (p) => !!p.amount))
    }

    $scope.amountChanged = (p) => {
        if (!$scope.providerInitiative && p.amount && p.amount.slice(-1) !== ',') {
            p.amount = Number(p.amount.replace(',', '.'))
            if (p.amount > $scope.max) {
                p.amount = $scope.max
            } else if (p.amount < $scope.min) {
                p.amount = $scope.min
            }
            let totalAssigned = Number(p.amount)
            _.each(_.orderBy($scope.payments, 'id', 'asc'), (np) => {
                if (np.id < p.id) {
                    totalAssigned += Number(np.amount)
                }
                let leftToAssign = $scope.getTotalToDistribute() - totalAssigned
                if ((np.id === p.id) && (leftToAssign < 0)) {
                    np.amount += leftToAssign
                    leftToAssign = 0
                }
                const nbLeftToAssign = $scope.nbPayments - np.id
                if (np.id > p.id) {
                    const newAmount = MS.round(leftToAssign / nbLeftToAssign, 2)
                    np.amount = newAmount
                    totalAssigned += newAmount
                }
                np.amount = MS.round(Math.max(np.amount, 0), 2)
            })
        }
        sum()
    }

    $scope.close = $uibModalInstance.dismiss

    $scope.ok = () => {
        $scope.staggering = true
        const sepa = $scope.payments.length && {
            payments: _.map($scope.payments, (payment) => {
                return {
                    payment_date: moment(payment.payment_date, 'DDMMYYYY').format('YYYY-MM-DD'),
                    amount: payment.amount,
                }
            }),
            amount: getTotalToDistribute(),
            providerInitiative: $scope.providerInitiative,
        }
        $uibModalInstance.close({ cb: $scope.cb.amount && $scope.cb, sepa })
        $scope.staggering = false
    }
})
